module.exports = __webpack_public_path__ + "img/1-low.79b099b0.jpg";